<template lang="pug">
.sensitiveWord
  .add-sensitiveWord(ref="addBlacklistRef")
    .add-sensitiveWord__title 添加敏感词
    el-form(ref="ruleFormRef" :model="form" :rules="rules" label-width="100px")
      el-form-item(label="敏感词" prop="word")
        el-input(
          v-model="form.word"
          placeholder="请输入敏感词(多个用逗号分割或换行分割)"
          type="textarea"
          :rows="5"
          clearable
        )
    .add-sensitiveWord__button
      el-button(
        type="primary"
        @click="addSensitiveWord()"
      ) 添加
  .tags__title 敏感词
  .tags__content
    .tags(v-if="currentData.length")
      el-tag(v-for="item,i in currentData" closable @close="handelClose(item,i)" :key="item.word") {{ item.word }}
    .not__available(v-else) 暂无敏感词
</template>
<script>
import api from '@/apis/sensitiveWord'
export default {
  name: 'sensitiv',
  props: {
    url: String,
    single: Object,
    title: String
  },
  data () {
    return {
      form: { word: '' },
      currentData: [],
      rules: {
        word: [
          { required: true, message: '请输入敏感词', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    this.getData()
    // 监听 粘贴事件
    document.removeEventListener('paste', null)
    document.addEventListener('paste', function (e) {
      const pasteData = e.clipboardData
        .getData('text')
        .split(/[\r\n\t' '。、；;]/)
        .filter((item) => item !== '')
        .join(',')
      this.form.word += pasteData
      e.preventDefault()
    })
  },
  methods: {
    // 新增敏感词
    async addSensitiveWord () {
      this.$refs.ruleFormRef.validate(async (valid, fields) => {
        if (valid) {
          const isExists = []
          const addData = []
          // 可以添加多个，使用中英文逗号或换行分割
          this.form.word
            .replaceAll(/[/\n，]/g, ',')
            .split(',')
            .forEach((text) => {
              // 不能重复添加
              if (this.currentData.some(item => item.word === text)) {
                isExists.push(text)
              } else if (text && !addData.some(item => item.word === text)) {
                addData.push({ word: text })
              }
            })
          if (isExists.length) {
            this.$message({ type: 'error', message: `敏感词 “${isExists.join('，')}” 已存在，不能重复添加，请修改后再添加！` })
          }

          // 添加数据
          if (addData.length) {
            const res = await api.reqAddSensitiveWord(addData)
            if (res.errCode === 0 && res.data && res.data.length) {
              this.currentData = res.data.concat(this.currentData)
              this.form.word = ''
              this.$message({ type: 'success', message: '添加成功' })
            }
          }
        } else {
          console.error('error submit!', fields)
        }
      })
    },

    // 删除敏感词
    async handelClose (item, index) {
      const res = await api.reqDelSensitiveWord({ id: item._id })
      if (res.errCode === 0) this.currentData.splice(index, 1)
    },

    // 初始化获取数据
    async getData   () {
      const res = await api.reqGetAllSensitiveWord()
      if (res.errCode === 0) this.currentData = res.data
    }
  }
}
</script>
<style lang="scss" scoped>
.sensitiveWord {
  padding: 20px 40px;
  .add-sensitiveWord {
    width: 800px;
    display: flex;
    flex-direction: column;
    .add-sensitiveWord__title {
      font-size: 18px;
      font-weight: 600;
      margin: 10px 0 20px;
    }
    .add-sensitiveWord__button {
      align-self: flex-end;
    }
  }
  .tags__title {
    font-size: 18px;
    font-weight: 600;
    margin: 20px 0 10px;
  }
  .tags__content {
    border-radius: 6px;
    max-height: calc(100vh - 420px);
    min-height: 300px;
    padding-left: 10px;
    border: 1px solid #eaeaea59;
    overflow-y: auto;
    .tags {
      padding: 10px 2px;
    }
    .not__available {
      font-weight: 600;
      margin: 30px 40px;
    }
    .el-tag {
      margin-right: 10px;
      margin-bottom: 10px;
    }
  }
}
</style>
